<template>
  <v-layout row wrap>
    <DiskItem v-for="disk in disks" :diskData="disk" :key="disk.id" />
    <v-flex xs12>
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" class="ml-0 mt-3" v-on="on">Добавить диск</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Добавление диска</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field label="Название диска" required v-model="label"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="['google']"
                    label="Тип"
                    required
                    v-model="type"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false">Отмена</v-btn>
            <v-btn color="blue darken-1" flat @click="createVolume">Добавить диск</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import DiskItem from './DiskItem'

export default {
  name: 'DiskList',
  components: {
    DiskItem
  },
  created() {
    this.$store.dispatch('disk/volume')
    .catch(error => {
        if (error.response.status == 403) {
            this.$dmsErrorNoty('Для данного пользователя доступ к дискам запрещен');
        } else {
          this.$dmsErrorNoty('Возникла ошибка при попытке доступа к дискам');
        } 
      throw error;
    })

  },
  data() {
    return {
      dialog: false,
      label: '',
      type: 'google',
    }
  },
  computed: {
    disks() {
      return this.$store.getters['disk/disks']
    }
  },
  methods: {
    createVolume() {
      let data = {
        label: this.label,
        type: this.type
      }
      this.$store.dispatch('disk/createVolume', data).then( response => {
        this.$dmsSuccessNoty('Диск успешно добавлен')
        this.dialog = false
      })
      .catch(error => {
        if (error.response.status == 403) {
            this.$dmsErrorNoty('Для данного пользователя добавление дисков запрещено');
        } else {
          this.$dmsErrorNoty('Возникла ошибка при попытке создания нового диска');
        }
        throw error;
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/apps/disk/components/Dashboard/DiskList.vue